import React, { useState } from 'react'
import { CircularProgress } from '@material-ui/core'
import PropTypes from 'prop-types'

const Image = ({ src, altText, ...rest }) => {
  const [ imageLoaded, setImageLoaded ] = useState(false)
  return (
    <div>
      <CircularProgress
        size={ 30 }
        style={ imageLoaded ? { display: 'none' } : { margin: '30px 0px' } }
      />
      <img
        src={ src }
        alt={ altText || 'image' }
        onLoad={ () => setImageLoaded(true) }
        style={ imageLoaded ? {} : { display: 'none' } }
        { ...rest }
      />
    </div>
  )
}

export default Image

Image.propTypes = {
  src: PropTypes.string.isRequired,
  imageProps: PropTypes.objectOf.isRequired,
  altText: PropTypes.string.isRequired,
}
